import { postWitHeaderLoge } from './index';

export  default function lodgeCliam(body){
    return postWitHeaderLoge('lodgeClaim',body);
}
